<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="inherit" :d="svgPath" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Call',
  computed: {
    svgPath(): string {
      let path =
        'M19.95 21c-2.15 0-4.246-.48-6.287-1.438a19.045 19.045 0 0 1-5.425-3.8 19.045 19.045 0 0 1-3.8-5.';
      path +=
        '425C3.479 8.296 3 6.2 3 4.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3H8.1a.96.96 0 0 1 .625.225.88.88 0 0 1 .';
      path +=
        '325.575l.65 3.5c.033.233.03.446-.012.637a1.027 1.027 0 0 1-.288.513L6.975 10.9c.7 1.2 1.58 2.325 2.638 3.';
      path +=
        '375A18.626 18.626 0 0 0 13.1 17l2.35-2.35c.15-.15.346-.263.588-.338.241-.075.479-.095.712-.062l3.45.7c.';
      path +=
        '233.05.425.162.575.337.15.175.225.38.225.613v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3ZM6.025 9l1.65-1.';
      path += '65L7.25 5H5.025c.083.683.2 1.358.35 2.025.15.667.367 1.325.65 1.975ZM19 18.';
      path +=
        '95v-2.2l-2.35-.475-1.675 1.675c.65.283 1.313.508 1.988.675.675.167 1.354.275 2.037.325Z';
      return path;
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

svg {
  margin-right: rem-calc(16px);

  path {
    fill: $black;
  }
}
</style>
